import { z } from "zod";
import { createEndpoint } from "../createEndpoint";
import { HttpClient, QueryParams } from "../httpClient";
import { PartnerBadgeSchema } from "../schemas/badge";

export interface ExpertBadgeSearchQueryParams extends QueryParams {
    search?: string;
}

export function createExpertBadgesApi(http: HttpClient, baseUrl: string) {
    const expertBadgesBaseUrl = `${baseUrl}/expert/badges`;
    
    return {
        searchBadges: createEndpoint<
            z.infer<typeof PartnerBadgeSchema>[],
            unknown,
            ExpertBadgeSearchQueryParams
        >(http, "GET", "/search", {
            base: expertBadgesBaseUrl,
            responseSchema: z.array(PartnerBadgeSchema),
        }),
    };
}

